import React from "react";
import { Button, Modal } from "react-bootstrap";
import { ActionHandlerFunction } from "@preveil-api";
import { AdminUIActionTypes } from "src/common";
import { Icon } from "src/components";

type AllProps = {
  show_modal: boolean;
  handleAction: ActionHandlerFunction;
}

function ToggleChangeWarningComponent(props: AllProps) {
  const { show_modal, handleAction } = props;
  
  function handleShowModal() {
    handleAction({ actionType: AdminUIActionTypes.SetShow });
  }

  return <Modal size="lg" show={show_modal} onHide={() => handleShowModal()} centered aria-label="Device Settings Change">
    <Modal.Header closeButton>
      <Modal.Title>Device Settings Change</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p className="mb-3">Are you sure you want to make this change?</p>
      <div className="d-flex align-items-baseline">
        <Icon className="icon-warning warning-yellow" />
        <p className="ms-2 mb-1">It will mean:</p>
      </div>
      <ul className="ps-4 mb-4">
        <li className="m-0">Users will be prevented from adding PreVeil to a device.</li>
        <li>Users will <b><i>not</i></b> be able to recover their accounts with their recovery file unless they are granted multiple device access.</li>
      </ul>
      <Button className="me-2" variant="outline-primary" onClick={() => handleAction({ actionType: AdminUIActionTypes.Confirm })}>Yes</Button>
      <Button onClick={() => handleShowModal()}>Cancel</Button>
    </Modal.Body>
  </Modal>;
}

export default React.memo(ToggleChangeWarningComponent);